import { render, staticRenderFns } from "./mentiontag_suggest.vue?vue&type=template&id=49645543&"
import script from "./mentiontag_suggest.vue?vue&type=script&lang=js&"
export * from "./mentiontag_suggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports